import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ItemsRoutingModule } from './items-routing.module';
import { ItemsComponent } from './items.component';

import { PipeCustomModule } from 'my-lib-sanfelici';
import { ItemsByCategoriaComponent } from './items-by-categoria/items-by-categoria.component';
import { ItemsSearchComponent } from './items-search/items-search.component';
import { ItemsDetailsComponent } from './items-details/items-details.component';
import { ItemsEditComponent } from './items-edit/items-edit.component';
import { ItemsListComponent } from './items-list/items-list.component';
import { ItemsCreateComponent } from './items-create/items-create.component';
import { ItemSingleComponent } from './item-single/item-single.component';
import { ItemUploadImageComponent } from './item-upload-image/item-upload-image.component';
import { FormsModule } from '@angular/forms';
import { StorageModule } from '../storage/storage.module';
import { MyCustomMaterialModule } from 'san-common';
import { CategorieModule } from '../categorie/categorie.module';
import { ItemsSharedModule } from 'modul-shared';



@NgModule({
  declarations: [ItemsComponent,
    ItemsByCategoriaComponent,
    ItemsSearchComponent,
    ItemsDetailsComponent,
    ItemsEditComponent,
    ItemsListComponent,
    ItemsCreateComponent,
    ItemSingleComponent,
    ItemUploadImageComponent
],
  imports: [
    CommonModule,
    ItemsRoutingModule,    
    CategorieModule,
    MyCustomMaterialModule,
    PipeCustomModule,
    ItemsSharedModule,
    FormsModule,
    StorageModule

  ],
  exports: [ItemsComponent,
    ItemsByCategoriaComponent,
    ItemsSearchComponent,
    ItemsDetailsComponent,
    ItemsEditComponent,
    ItemsListComponent,
    ItemsCreateComponent,    
    ItemSingleComponent,
    ItemUploadImageComponent
  ]
})
export class ItemsModule { }
